@if (event) {
<div class="d-flex align-items-center">
    @if (showIcon) {
    <div class="pe-1 d-flex">
        <img src="assets/icons/icons-alt/route-alt-1.svg" alt="Running"/>
    </div>
    }
    <p class="text-truncate" [class]="cssClass">
        @for (length of event! | eventLengths; track length; let idx = $index; let last = $last) {
        {{ length | raceLengthFormat }}
        @if (!last) {
            <span class=""> | </span>
         }
        }
    </p>
</div>
}